import { render, staticRenderFns } from "./authoriseClosure.vue?vue&type=template&id=065afe01&"
import script from "./authoriseClosure.vue?vue&type=script&lang=js&"
export * from "./authoriseClosure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports